import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import ClinicAuthGuard from 'src/auth/guard/clinic-auth-guard';
import ClinicDashboardLayout from 'src/layouts/clinic-dashboard/layout';
import { LoadingScreen } from 'src/components/loading-screen';

import ClinicBusinessProfilePage from 'src/pages/clinic-dashboard/business-profile/clinic-business-profile';
import ClinicBusinessProfileEditPage from 'src/pages/clinic-dashboard/business-profile/clinic-business-profile-edit-page';
import ClinicAddPackagePage from 'src/pages/clinic-dashboard/packages/clinic-package-add-page';
import ClinicPackagesPage from 'src/pages/clinic-dashboard/packages/clinic-packages-page';
import ClinicDoctorPage from 'src/pages/clinic-dashboard/doctors/clinic-doctor-page';
import AddClinicDoctorPage from 'src/pages/clinic-dashboard/doctors/add-clinic-doctor-page';
import ClinicEditPackagePage from 'src/pages/clinic-dashboard/packages/clinic-package-edit-page';

import TelehealthListPage from 'src/pages/clinic-dashboard/telehealth/telehealth-packages-view';
import TelehealthAddPage from 'src/pages/clinic-dashboard/telehealth/telehealth-packages-add-page';
import TelehealthEditPage from 'src/pages/clinic-dashboard/telehealth/telehealth-package-edit-page';

import TelecarePackagesListPage from 'src/pages/clinic-dashboard/telepackages/telepackages-view';
import TelecarePackageAddPage from 'src/pages/clinic-dashboard/telepackages/telepackages-add-page';
import TelecarePackageEditPage from 'src/pages/clinic-dashboard/telepackages/telepackages-edit-page';

import EnquiryDetailsPage from 'src/sections/dashboard/enquires/enquiry-details';
import EnquiryListView from 'src/sections/dashboard/enquires/enquiry-list-view';

import ClinicProductsPage from 'src/pages/clinic-dashboard/products/products-view';
import ClinicAddProductPage from 'src/pages/clinic-dashboard/products/products-page-add-view';
import ClinicEditProductPage from 'src/pages/clinic-dashboard/products/products-page-edit-view';

const IndexPage = lazy(() => import('src/pages/clinic-dashboard/clinic-dashboard-home'));
const PageClinicList = lazy(() => import('src/pages/dashboard/clinic-list'));

const TELE_CLINIC_ID = process.env.REACT_APP_TELE_CLINIC_ID;

export const clinicDashboardRoutes = [
  {
    path: 'clinic-dashboard',
    element: (
      <ClinicAuthGuard>
        <ClinicDashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </ClinicDashboardLayout>
      </ClinicAuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: 'clinic-profile', element: <PageClinicList /> },
      { path: 'business-profile', element: <ClinicBusinessProfilePage /> },
      { path: 'business-profile/edit', element: <ClinicBusinessProfileEditPage /> },

      { path: 'packages', element: <ClinicPackagesPage /> },
      { path: 'packages/add', element: <ClinicAddPackagePage /> },
      { path: 'packages/:packageId/edit', element: <ClinicEditPackagePage /> },

      { path: 'products', element: <ClinicProductsPage /> },
      { path: 'products/add', element: <ClinicAddProductPage /> },
      { path: 'products/:productId/edit', element: <ClinicEditProductPage /> },

      { path: 'doctors', element: <ClinicDoctorPage /> },
      { path: 'doctors/add', element: <AddClinicDoctorPage /> },

      { path: 'enquires', element: <EnquiryListView /> },
      { path: 'enquires/:enquiryId', element: <EnquiryDetailsPage /> },

      {
        path: 'telepackages',
        element: (
          <ClinicAuthGuard allowedClinicId={TELE_CLINIC_ID}>
            <Outlet />
          </ClinicAuthGuard>
        ),
        children: [
          { path: '', element: <TelecarePackagesListPage /> },
          { path: 'add', element: <TelecarePackageAddPage /> },
          { path: ':telepackagesId/edit', element: <TelecarePackageEditPage /> },
        ],
      },

      {
        path: 'telehealths',
        element: (
          <ClinicAuthGuard allowedClinicId={TELE_CLINIC_ID}>
            <Outlet />
          </ClinicAuthGuard>
        ),
        children: [
          { path: '', element: <TelehealthListPage /> },
          { path: 'add', element: <TelehealthAddPage /> },
          { path: ':therapyId/edit', element: <TelehealthEditPage /> },
        ],
      },
    ],
  },
];
